import { devtoolsExchange } from "@urql/devtools"
import { authExchange } from "@urql/exchange-auth"
import { cacheExchange, createClient, fetchExchange, makeOperation } from "urql"
import { getAuthToken } from "~/modules/authentication"
import { API_URL } from "~/utils/env"

interface AuthState {
  token: string
}

const url = `${API_URL}/graphql`

export const client = createClient({
  url,
  exchanges: [
    devtoolsExchange,
    cacheExchange,
    authExchange(async (utils) => {
      const authToken = getAuthToken()

      return {
        addAuthToOperation: (operation) => {
          if (!authToken) {
            return operation
          }

          return utils.appendHeaders(operation, {
            Authorization: `Bearer ${authToken}`,
          })
        },
        didAuthError: (error, _operation) => {
          return error.graphQLErrors.some(
            (e) => e.extensions?.code === "UNAUTHENTICATED",
          )
        },
        async refreshAuth() {
          // Do nothing
        },
      }
    }),
    fetchExchange,
  ],
})
